import React, { createContext, useState, useEffect, useContext } from 'react';
import API from '../utils/api';

// Crear el contexto
export const ConfigContext = createContext();

// Hook personalizado para usar el contexto
export function useConfig() {
  return useContext(ConfigContext);
}

// Proveedor del contexto
export function ConfigProvider({ children }) {
  // Estados para almacenar las configuraciones
  const [systemConfig, setSystemConfig] = useState(null);
  const [appConfig, setAppConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  // Cargar las configuraciones al montar el componente
  useEffect(() => {
    loadConfigs();
  }, []);

  // Función para cargar las configuraciones desde localStorage
  const loadConfigs = () => {
    setLoading(true);

    try {
      // Obtener configuraciones desde localStorage
      const sysConfig = API.auth.getSystemConfig();
      const applicationConfig = API.auth.getAppConfig();

      setSystemConfig(sysConfig);
      setAppConfig(applicationConfig);
    } catch (error) {
      console.error('Error al cargar configuraciones:', error);
    } finally {
      setLoading(false);
    }
  };

  // Función para actualizar la configuración del sistema
  const updateSystemConfig = (newConfig) => {
    setSystemConfig(newConfig);
    API.utils.updateSystemConfig(newConfig);
  };

  // Función para actualizar la configuración de la aplicación
  const updateAppConfig = (newConfig) => {
    setAppConfig(newConfig);
    API.utils.updateAppConfig(newConfig);
  };

  // Valor del contexto
  const contextValue = {
    systemConfig,
    appConfig,
    loading,
    updateSystemConfig,
    updateAppConfig,
    reloadConfigs: loadConfigs
  };

  return (
    <ConfigContext.Provider value={contextValue}>
      {!loading && children}
    </ConfigContext.Provider>
  );
}

export default ConfigContext;